import { createContext, useContext, useMemo, type ReactNode } from 'react';
import type { ApiClient } from '@mrrmlab/api-client';

interface ContextValue {
  client: ApiClient;
}

const DayPlannerContext = createContext<ContextValue | null>(null);

export interface DayPlannerApiClientProviderProps {
  client: ApiClient;
  children: ReactNode;
}

export function DayPlannerApiClientProvider({ client, children }: DayPlannerApiClientProviderProps) {
  const value = useMemo<ContextValue>(() => ({ client }), [client]);
  return <DayPlannerContext.Provider value={value}>{children}</DayPlannerContext.Provider>;
}

export function useApiClient(): ApiClient {
  const ctx = useContext(DayPlannerContext);
  if (!ctx) {
    throw new Error(
      '[feature-day-planner] useApiClient called outside <DayPlannerApiClientProvider>. ' +
        'Wrap your app with <DayPlannerApiClientProvider client={...}> at the route root.',
    );
  }
  return ctx.client;
}
